import {AxiosInstance, AxiosRequestConfig} from 'axios';
import axios, {AxiosError} from 'axios';

type ApiUnauthorizedInterceptor = (error: AxiosError) => void

export interface AppAxiosRequestConfig extends AxiosRequestConfig {
    baseURL: string;
}

export interface ApiAxiosInstance extends AxiosInstance {
    setToken(token: string): void;

    setBaseUrl(url: string): void;

    enableUnauthorizedInterceptor(): void;

    setUnauthorizedInterceptor(callback: ApiUnauthorizedInterceptor): void

    disableUnauthorizedInterceptor(): void;

    unauthorizedInterceptorCallback?: (error: any) => void;
    unauthorizedInterceptorId?: number | null;
}

export function create() {

    const api: ApiAxiosInstance = axios.create({}) as ApiAxiosInstance;

    api.defaults

    api.setToken = function (token: string): void {
        this.defaults.headers["Authorization"] = token;
    };

    api.setBaseUrl = function (url: string): void {
        this.defaults.baseURL = url;
    };

    api.disableUnauthorizedInterceptor = function (): void {
        if (null !== this.unauthorizedInterceptorId && undefined !== this.unauthorizedInterceptorId) {
            this.interceptors.response.eject(this.unauthorizedInterceptorId);
            delete this.unauthorizedInterceptorId;
        }
    };

    api.enableUnauthorizedInterceptor = function (): void {
        if (this.unauthorizedInterceptorCallback) {

            this.unauthorizedInterceptorId = api.interceptors.response.use(null, (error: any) => {
                if (isUnauthorizedResponse(error) && this.unauthorizedInterceptorCallback) {

                    this.unauthorizedInterceptorCallback(error);
                }

                return Promise.reject(error);
            });
        }
    };

    api.setUnauthorizedInterceptor = function (callback: ApiUnauthorizedInterceptor): void {
        this.unauthorizedInterceptorCallback = callback;
        this.enableUnauthorizedInterceptor();
    };

    return api;
}

export function isUnauthorizedResponse(error: any): boolean {
    return !!(error.response && 401 === error.response.status);
}

